import { HttpErrorResponse } from '@angular/common/http';
import {
  PaymentPreviewV1Response,
  PaymentProcess,
  SessionPayment,
} from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PoiIntSelectPaymentTypeSessionActions = createActionGroup({
  source: 'POI Int Select Payment Type Component Session',
  events: {
    'Submit Payment Preview Complete': props<{
      payload: PaymentPreviewV1Response;
      paymentProcess: PaymentProcess;
    }>(),
    'Submit Payment Preview Error': props<{
      payload: HttpErrorResponse;
    }>(),
    'Update Session Payment Success': props<{
      response: SessionPayment;
    }>(),
    'Update Session Payment Error': props<{
      error: HttpErrorResponse;
    }>(),
    'Update Session Payment Status Success': emptyProps(),
    'Update Session Payment Status Error': props<{
      error: HttpErrorResponse;
    }>(),
    'Update Session Redirect State Success': emptyProps(),
    'Update Session Redirect State Error': props<{
      error: HttpErrorResponse;
    }>(),
  },
});
